module.exports = __webpack_public_path__ + "static/img/19.01d4cb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/19.png
// module id = k7I9
// module chunks = 0